// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-family: "Titillium Web";
  --font-size-xxl: 40px;
  --font-size-xl: 30px;
  --font-size-l: 20px;
  --font-size-m: 16px;
  --font-size-s: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/variables/font.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[":root {\n  --font-family: \"Titillium Web\";\n  --font-size-xxl: 40px;\n  --font-size-xl: 30px;\n  --font-size-l: 20px;\n  --font-size-m: 16px;\n  --font-size-s: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
